import { useApp } from '../context/AppContext';

export default function NotificationPanel() {
  const { notifications, notifPanelOpen, setNotifPanelOpen, markAllRead, goto } = useApp();

  if (!notifPanelOpen) return null;

  return (
    <>
      <div
        style={{ position: 'fixed', inset: 0, zIndex: 89 }}
        onClick={() => setNotifPanelOpen(false)}
      />
      <div className="notif-panel open">
        <div className="notif-hd">
          <span className="notif-hd-title">Notifications</span>
          <button
            className="btn btn-ghost btn-xs"
            onClick={(e) => { e.stopPropagation(); markAllRead(); }}
          >
            Mark all read
          </button>
        </div>
        {notifications.length === 0 ? (
          <div style={{ padding: '16px', textAlign: 'center', fontSize: 12, color: 'var(--tx3)' }}>
            No notifications
          </div>
        ) : (
          notifications.map(n => (
            <div
              key={n.id}
              className={`notif-item${n.read ? '' : ' unread'}`}
              onClick={() => { setNotifPanelOpen(false); if (n.link) goto(n.link); }}
            >
              <div className="notif-ico">{n.icon}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="notif-title">{n.title}</div>
                <div className="notif-body">{n.body}</div>
                <div className="notif-time">{n.time}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
}
